import { Component, OnInit } from "@angular/core";
import { ILang } from "src/app/model/entities/lang.interface";
import { ISettings } from "src/app/model/entities/settings.interface";
import { IWords } from "src/app/model/entities/words.interface";
import { AppService } from "../../services/app.service";

enum CurrencyEnum {
    USD, EUR
};

@Component({
    selector: "the-calculator",
    templateUrl: "calculator.component.html",
    styleUrls: ["calculator.component.scss"],
})
export class CalculatorComponent implements OnInit {
    public moneyValue: number = 2500;  
    public dayValue: number = 50;
    public activeCurrency: CurrencyEnum = 0;
    public total: string = '';

    public moneyStepsArray: any[] = [
        { value: 200   },
        { value: 500   },
        { value: 1000  },
        { value: 2500  },
        { value: 20000 },
        { value: 50000 },
    ];

    public daysStepsArray: any[] = [
        { value: 3 },
        { value: 10 },
        { value: 50 },
        { value: 100 },
        { value: 200 },
        { value: 360 },
    ];

    public moneyDefaultValue: any;
    public daysDefaultValue: any;

    constructor(
        private appService: AppService,
    ) {}

    get lang(): ILang {return this.appService.lang;}
    get words(): IWords {return this.appService.words;}  
	  get settings(): ISettings {return this.appService.settings;}
	  get rate(): number {return parseFloat(this.settings?.['calculator-rate']);}

    ngOnInit(): void {
        this.moneyDefaultValue = this.moneyStepsArray[this.moneyStepsArray.length - 1];
        this.daysDefaultValue = this.daysStepsArray[this.daysStepsArray.length - 1];
    }

    private isLeapYear(year: number): boolean {
        return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
    }

    private daysOfYear(year: number): number {
        return this.isLeapYear(year) ? 366 : 365;
    }

    private calculateTotal(): void {
        const moneyPerDay: number = this.moneyValue / 100 * this.rate / this.daysOfYear((new Date()).getFullYear());
        this.total = (this.moneyValue + moneyPerDay * this.dayValue).toFixed(2);
    }

    public moneyValueChange(event: number) {
        this.moneyValue = event;
        this.calculateTotal();
    }

    public daysValueChange(event: number) {
        this.dayValue = event;
        this.calculateTotal();
    }
}
